import { PropsLogo } from './PropsLogo';
import { MyLink } from '@ui-kit/Link';

import IconLogo from './logo2.svg';
import IconFooterLogo from './logo-footer.svg';

export const Logo = ({ className, width, height, theme = 'header' }: PropsLogo): JSX.Element => {
  return (
    <MyLink className={className} href="/">
      {theme === 'header' && <IconLogo width={width} height={height} />}
      {theme === 'footer' && <IconFooterLogo width={width} height={height} />}
    </MyLink>
  );
};
